import React, { useEffect } from 'react';
import { setCookie } from 'helpers/cookie';

const ProductCookieHandler: React.FC = () => {
    useEffect(() => {
        const currentUrl = document.location.href;
        const currentHash = document.location.hash;
        const referrer = document.referrer;

        if (
            !document.cookie.includes('ib1=')
            || String(referrer).indexOf('https://www.skapiec.pl') !== 0
            || ['utm_source', 'gclid', 'fbclid'].some(item => currentUrl.includes(item))
            || String(currentHash).indexOf('from') > -1
        ) {
            const rot13 = (str: string): string => String(str)
                .replace(/[a-zA-Z]/gi, s => String.fromCharCode(s.charCodeAt(0) + (s.toLowerCase() < 'n' ? 13 : -13)));
            const value = rot13([currentUrl, referrer].map(encodeURIComponent).join(';;'));
            setCookie('ib1', value, { expiresDays: 30, path: '/', secure: true });
        }
    }, []);

    return null;
};

export default ProductCookieHandler;
